import React from "react";
import profile from "../assets/profile.jpg";
import { motion } from "framer-motion";

function About() {
  return (
    <motion.div
      className="md:h-screen md:mb-0 mb-[200px] "
      id="about"
      initial={{ x: "-100vw", opacity: 0.1 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ type: "spring", delay: 0.5, stiffness: 120 }}
    >
      <div className="flex items-center gap-4 justify-center md:justify-start">
        <div className="w-[10%] h-0.5 bg-[#ccd6f6] rounded-full"></div>
        <h3 className="text-center md:text-left font-bold text-2xl md:text-4xl mb-[10px] md:mb-[30px]">
          About Me
        </h3>
        <div className="w-[10%] h-0.5 bg-[#ccd6f6] rounded-full"></div>
      </div>
      <div className="flex flex-col-reverse md:flex-row">
        <div className="text-justify md:w-[60%] px-[50px] md:px-0   md:mx-0 md:text-start text-xs md:text-base">
          <p className="">
            Hello! I am Qozeem Opeyemi Salami, a junior Frontend Developer from
            Nigeria. I am a graduate of Altschool Africa's School of Engineering
            for a Diploma in Software Engineering. <br /> <br /> I transitioned
            into tech in the year 2021 with a focus on UI/UX, but after taking
            some HTML classes, I discovered my passion for building beautiful
            and responsive websites and web apps. In addition to my studies at
            Altschool Africa, I am also a graduate of Building from Obafemi
            Awolowo University in Ile-Ife, Nigeria. <br /> <br /> I am excited
            to continue learning and growing as a developer, and I am eager to
            put my skills to work on exciting projects.
          </p>
          <br />
          <p className="text-center md:text-start">
            Here are a few of my skills
          </p>
          <ul className="flex gap-[5%] flex-wrap justify-center items-center">
            <li>HTML</li>
            <li>JavaScript</li>
            <li>CSS</li>
            <li>ReactJS</li>
            <li>TailwindCSS</li>
            <li>ChakraUI</li>
            <li>VueJS</li>
            <li>NextJS</li>
          </ul>
        </div>
        <div className="relative mb-[30px]">
          <div className="w-[50%] h-[223px] md:h-[325px] border-[2px] border-solid  rounded-lg absolute left-[125px] md:left-[175px] top-4 hidden md:block "></div>
          <img
            src={profile}
            alt=""
            className="w-[50%] rounded-lg mx-auto mb-[20px] relative z-10 "
          />
        </div>
      </div>
    </motion.div>
  );
}

export default About;
